<template>
  <v-container fluid>
    <v-card class="border-top-blue">
      <v-card-text>
        <figures-list></figures-list>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import FiguresList from '../components/FiguresList';

export default {
  name: 'figures-page',
  components: {
    FiguresList
  }
};
</script>
